import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private enumCache: Map<string, Observable<Record<string, { description?: string; value?: unknown }>>> = new Map();
  private allEnumsCache: Observable<Record<string, Record<string, { description?: string; value?: unknown }>>> | null = null;
  private allEnumsData: Record<string, Record<string, { description?: string; value?: unknown }>> | null = null;
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /** Busca todos os enums de uma vez (GET /api/commons/enums sem enumName), como o AngularJS. */
  private getAllEnums(): Observable<Record<string, Record<string, { description?: string; value?: unknown }>>> {
    if (this.allEnumsCache) {
      return this.allEnumsCache;
    }

    if (this.allEnumsData) {
      return of(this.allEnumsData);
    }

    this.allEnumsCache = this.http.get<Record<string, Record<string, { description?: string; value?: unknown }>>>(`${this.apiUrl}/commons/enums`).pipe(
      map(response => {
        this.allEnumsData = response || {};
        return this.allEnumsData;
      }),
      catchError(error => {
        if (error.status === 403) {
          // pode ser normal (enum indisponível pro usuário)
        } else if (error.status === 404) {
          // pode ser normal (endpoint ausente)
        }
        this.allEnumsData = {};
        return of({});
      }),
      shareReplay(1)
    );

    return this.allEnumsCache;
  }

  /** @param enumName Ex: 'SituacaoMatricula', 'SituacaoItemEducacional', 'GrupoEnturmacaoCor' */
  getEnum(enumName: string): Observable<any> {
    if (this.allEnumsData && this.allEnumsData[enumName]) {
      const enumData = this.allEnumsData[enumName];
      return of(enumData);
    }

    if (this.enumCache.has(enumName)) {
      return this.enumCache.get(enumName)!;
    }

    const enumRequest = this.getAllEnums().pipe(
      map(allEnums => {
        const enumData = allEnums[enumName] || {};
        if (enumData && typeof enumData === 'object') {
          return enumData;
        }
        return {};
      }),
      shareReplay(1)
    );

    this.enumCache.set(enumName, enumRequest);
    return enumRequest;
  }
}